import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setNomeAdministracaoConsultaAtaRegistroPrecoMP: ['nomeAdministracao'],
    setAtivoConsultaAtaRegistroPrecoMP: ['ativo'],
    setExercicioConsultaAtaRegistroPrecoMP: ['exercicio'],
    setNumeroConsultaAtaRegistroPrecoMP: ['numero'],
    setExercicioLicitacaoConsultaAtaRegistroPrecoMP: ['exercicioLicitacao'],
    setNumeroLicitacaoConsultaAtaRegistroPrecoMP: ['numeroLicitacao'],
    setObjetoConsultaAtaRegistroPrecoMP: ['objeto'],
    limpaFiltroConsultaAtaRegistroPrecoMP: [],
    receberFiltroConsultaAtaRegistroPrecoMP: ['filtroRecebido'],
    setStatusConsultaAtaRegistroPrecoMP: ['status'],
    setDataFimInicialConsultaAtaRegistroPrecoMP: ['dataFimInicial'],
    setDataFimFinalConsultaAtaRegistroPrecoMP: ['dataFimFinal'],
})

const INITIAL_STATE = {
    administracao: [],
    ativo: '',
    exercicio: new Date().getFullYear(),
    numero: '',
    exercicioLicitacao: '',
    numeroLicitacao: '',
    objeto: '',
    dataFimInicial: '',
    dataFimFinal: '',
    status: { label: '', value: '' },
}

const setNomeAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.nomeAdministracao }
}

const setAtivo = (state = INITIAL_STATE, action) => {
    return { ...state, ativo: action.ativo }
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setNumero = (state = INITIAL_STATE, action) => {
    return { ...state, numero: action.numero }
}

const setExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: action.exercicioLicitacao }
}

const setNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: action.numeroLicitacao }
}

const setObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: action.objeto }
}

const setDataFimInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataFimInicial: action.dataFimInicial }
}
const setDataFimFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataFimFinal: action.dataFimFinal }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_DATA_FIM_INICIAL_CONSULTA_ATA_REGISTRO_PRECO_MP]: setDataFimInicial,
    [Types.SET_DATA_FIM_FINAL_CONSULTA_ATA_REGISTRO_PRECO_MP]: setDataFimFinal,
    [Types.SET_NOME_ADMINISTRACAO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setNomeAdministracao,
    [Types.SET_ATIVO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setAtivo,
    [Types.SET_EXERCICIO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setExercicio,
    [Types.SET_NUMERO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setNumero,
    [Types.SET_EXERCICIO_LICITACAO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setExercicioLicitacao,
    [Types.SET_NUMERO_LICITACAO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setNumeroLicitacao,
    [Types.SET_OBJETO_CONSULTA_ATA_REGISTRO_PRECO_MP]: setObjeto,
    [Types.LIMPA_FILTRO_CONSULTA_ATA_REGISTRO_PRECO_MP]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ATA_REGISTRO_PRECO_MP]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_ATA_REGISTRO_PRECO_MP]: setStatus,
})
